<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado borderTop v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">IMPOSTO DE IMPORTAÇÃO</h2>
    <QuadroAlerta
      v-if="!!imposto.dados.length"
      :classe="nomeImposto"
      :alerta="dadosAlerta"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :key="getRenderKey"
      :borderTop="!imposto.dados.length || !exibeAlerta"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <RegistrosImportacao
        :imposto="imposto"
        :seleciona="seleciona"
        :edita="edita"
        :registroSelecionado="registroSelecionado"
        :selecionouImportacao="selecionouImportacao"
      />
    </QuadroPrincipal>
  </div>
</template>

<script>
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import RegistrosImportacao from "@/components/RegistrosImportacao/RegistrosImportacao.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "Importacao",

  props: {
    id: String | Number,
    buscarImposto: Function,
    tributoAtivo: String,
    exibeImposto: Boolean,
    dadosForm: Array | Object
  },

  components: {
    LoadingResultado,
    MensagemErro,
    MultiplosSemResultado,
    QuadroAlerta,
    QuadroPrincipal,
    RegistrosImportacao
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "IMPORTAÇÃO",
      nomeImposto: "class_importacao",
      imposto: null,
      registroSelecionado: {},
      selecionouImportacao: false,
      erro: false,
      ativarLoading: false
    };
  },

  async created() {
    this.setSelecao({ selecao: { selecionouImportacao: this.selecionouImportacao }, id: this.id });
    this.ativarLoading = true;
    if (this.tributoAtivo == this.nomeImposto && !this.imposto && this.exibeImposto) {
      [this.imposto] = await this.buscarImposto({ imposto: this.nomeImposto, idCenario: this.id });
    }
    this.ativarLoading = false;
  },

  updated() {
    if (this.selecionouImportacao) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      this.ativarLoading = true;
      if (newValue == this.nomeImposto && !this.imposto && this.exibeImposto) {
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
      }
      this.ativarLoading = false;
    },

    ativarLoading() {
      this.$emit("loading", this.ativarLoading);
    },

    selecionouImportacao() {
      this.setSelecao({
        selecao: { selecionouImportacao: this.selecionouImportacao },
        id: this.id
      });
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),

    dadosAlerta() {
      let alerta = this.imposto.dados.filter(imposto => imposto.ordem == 101);
      return !!alerta.length ? alerta : null;
    },

    impressaoLog() {
      let log = {
        logImportacao: {
          imposto: this.registroSelecionado
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    seleciona(imposto) {
      this.registroSelecionado = imposto;
      this.selecionouImportacao = true;
    },

    edita() {
      this.registroSelecionado = {};
      this.selecionouImportacao = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
